var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.379132,
    y: 7.46657,
    width: 13.6998,
    height: 0.5,
    rx: 0.25,
    transform: "rotate(-31.2955 0.379132 7.46657)",
    fill: "#D9D9D9",
    stroke: "#8A94A6",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5137,
    y: 14.3303,
    width: 13.4717,
    height: 0.5,
    rx: 0.25,
    transform: "rotate(-32.5214 11.5137 14.3303)",
    fill: "#D9D9D9",
    stroke: "#8A94A6",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.629048,
    y: 7.24399,
    width: 13.3518,
    height: 0.51955,
    rx: 0.259775,
    transform: "rotate(31.5275 0.629048 7.24399)",
    fill: "#D9D9D9",
    stroke: "#8A94A6",
    strokeWidth: 0.51955
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.14145,
    y: 15.4434,
    width: 8.64452,
    height: 0.5,
    rx: 0.25,
    transform: "rotate(31.5275 4.14145 15.4434)",
    fill: "#D9D9D9",
    stroke: "#8A94A6",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9736,
    y: 19.9908,
    width: 9.39035,
    height: 0.510953,
    rx: 0.255477,
    transform: "rotate(-27.2921 10.9736 19.9908)",
    fill: "#D9D9D9",
    stroke: "#8A94A6",
    strokeWidth: 0.510953
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.96143,
    y: 15.959,
    width: 6.5,
    height: 0.5,
    rx: 0.25,
    transform: "rotate(-90 3.96143 15.959)",
    fill: "#D9D9D9",
    stroke: "#8A94A6",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9614,
    y: 15.959,
    width: 6.5,
    height: 0.5,
    rx: 0.25,
    transform: "rotate(-90 18.9614 15.959)",
    fill: "#D9D9D9",
    stroke: "#8A94A6",
    strokeWidth: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 21.25,
    y: 16.75,
    width: 8.5,
    height: 0.5,
    rx: 0.25,
    transform: "rotate(-90 21.25 16.75)",
    fill: "#D9D9D9",
    stroke: "#8A94A6",
    strokeWidth: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9774,
    y: 0.343824,
    width: 13.2273,
    height: 0.5,
    rx: 0.25,
    transform: "rotate(31.5275 11.9774 0.343824)",
    fill: "#D9D9D9",
    stroke: "#8A94A6",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/Students.456659c52e2d7c3236373788fe8c6646.svg";
export { ForwardRef as ReactComponent };